export default "__VITE_ASSET__ad45c091__"